import { useContext, useMemo } from "react";
import {
  BlankMediaTypeImporterManufEquipmentViewModel,
  SubmitBlankMediaImporterApplication,
} from "../../../../../../generated/data-contracts";
import { AvisContext } from "../../../../../shared/context";
import {
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../../shared/components/editableList";
import { AvisInputInt } from "../../../../../shared/components/inputs";
import { fieldCollectionEquipmentAndCNCode } from "./fields/SharedFieldCollection";
import { ApplicationSectionBase, ISectionSharedProps } from "../../forms";

export function BlankMediaApplicationManufEquipments(
  props: Readonly<ISectionSharedProps<SubmitBlankMediaImporterApplication>>,
) {
  const { bag, bagField, equipments, disabled, loading } = props;
  const { res } = useContext(AvisContext);
  const sharedFields = useMemo(
    () =>
      fieldCollectionEquipmentAndCNCode<BlankMediaTypeImporterManufEquipmentViewModel>(
        equipments,
        res,
        disabled,
      ),
    [equipments, res, disabled],
  );
  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<BlankMediaTypeImporterManufEquipmentViewModel>
  >[] = [
    ...sharedFields,
    {
      name: "count",
      title: res("blankMedia_Application_label_Count"),
      required: true,
      minWidth: 75,
      width: 75,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputInt
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]?.toString()}
            onChange={onChange}
            min={1}
            disabled={disabled}
            required={field.required}
            hideClear
          />
        );
      },
    },
  ];

  return (
    <ApplicationSectionBase
      title={res("blankMedia_Application_section_I_Manufactured")}
      textToDisplay="portal_TDN_ImporterReport_Manufactured"
      bag={bag}
      bagField={bagField}
      initValue={
        {
          rowState: "Add",
        } as IRowState<BlankMediaTypeImporterManufEquipmentViewModel>
      }
      fieldCollection={fieldCollection}
      loading={loading}
      disabled={disabled}
      forceUpdateKey={{ loading }}
    />
  );
}
